import global from '../global';
import has from '../../core/has';
export default function wrapper(nameOnGlobal, constructor = false, bind = false) {
    if (has('test')) {
        if (constructor) {
            return function (...args) {
                return new global[nameOnGlobal](...args);
            };
        }
        else {
            return function (...args) {
                return global[nameOnGlobal](...args);
            };
        }
    }
    return bind ? global[nameOnGlobal].bind(global) : global[nameOnGlobal];
}
//# sourceMappingURL=wrapper.mjs.map